module.exports = __webpack_public_path__ + "img/ico-telefono.7f3ee89e.svg";